/* ============================================================
   Pole Mom — gedeelde NL/EN tab-switcher (gedrag)
   ============================================================
   Gebruikt door: polemom-product-details, polemom-options,
   polemom-help-popup.

   Deze file kan op één productpagina via meerdere snippets tegelijk
   ingeladen worden (bv. product-details én de help-popup staan beide
   op dezelfde pagina). Daarom een idempotency guard bovenaan: zelfs
   als de <script>-tag twee of drie keer voorkomt, wordt de logica
   maar één keer geregistreerd. Losse <script src>-tags met dezelfde
   src worden door browsers namelijk NIET automatisch gededupliceerd
   (dat geldt wel voor <link rel="stylesheet">, dus daar is dit niet
   nodig) — zonder deze guard zou je dubbele event-listeners krijgen.
   ============================================================ */
(function () {
  if (window.PolemomTabs) return;

  function init(root) {
    if (!root || root.dataset.polemomTabsInit === "1") return;
    root.dataset.polemomTabsInit = "1";

    const panelsWrap = root.querySelector('.polemom-lang-panels');
    const buttons = Array.from(root.querySelectorAll('.polemom-lang-btn'));
    const panels = Array.from(root.querySelectorAll('.polemom-lang-panel'));
    const titles = Array.from(root.querySelectorAll('.polemom-title'));

    const rawDefault = (panelsWrap && panelsWrap.getAttribute('data-default-lang'))
      || root.getAttribute('data-locale')
      || 'nl';
    const defaultLang = rawDefault.toLowerCase() === 'en' ? 'en' : 'nl';

    function setLang(lang) {
      panels.forEach(p => p.classList.toggle('is-active', p.dataset.lang === lang));
      buttons.forEach(b => {
        const active = b.dataset.lang === lang;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      titles.forEach(t => t.style.display = (t.dataset.lang === lang ? 'inline' : 'none'));
    }

    buttons.forEach(btn => btn.addEventListener('click', () => setLang(btn.dataset.lang)));
    root.classList.add('has-js');
    setLang(defaultLang);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-polemom-tabs]').forEach(init);
  }

  window.PolemomTabs = { init: init, initAll: initAll };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
